import React from 'react';
import TextField from '../pages/OrderEntry/ui/TextField';
import { AsYouType } from 'libphonenumber-js';
import { checkIfInputContainsLettersOrNull } from './utilities/functions';

interface IProps {
  value: string;
  onChange: (val: string) => void;
  styles: any;
  width: any;
  label: string;
  name: string;
}

export default function PhoneNumberInput(props: IProps) {
  const onChange = (e: any) => {
    const hasAlphaCharachter = checkIfInputContainsLettersOrNull(e.target.value);
    props.onChange(hasAlphaCharachter ? e.target.value : new AsYouType('US').input(e.target.value));
  };
  return (
    <TextField
      name={props.name}
      label={props.label}
      width={props.width}
      value={props.value}
      onChange={onChange}
      styles={props.styles}
    />
  );
}
